module.exports = __webpack_public_path__ + "static/media/close-menu.dcb56ba1.svg";